"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor_1 = require("../../../../shared/components/editors/CardRowSelectEditor");
var CardRowNumericEditor_1 = require("../../../../shared/components/editors/CardRowNumericEditor");
var CardRowCheckBoxEditor_1 = require("../../../../shared/components/editors/CardRowCheckBoxEditor");
var DlgSmsRestrictionEditor = /** @class */ (function (_super) {
    __extends(DlgSmsRestrictionEditor, _super);
    function DlgSmsRestrictionEditor(props) {
        return _super.call(this, props) || this;
    }
    DlgSmsRestrictionEditor.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.controller.Subscribe("*", function (id, data) {
            _this.setState({
                visible: data.visible,
                dialogTitle: data.dialogTitle,
                action_val: data.actionVal,
                actions_avail: data.actionsAvail,
                completed_attempts_count: data.completedAttemptsCount,
                block_by_minutes: data.blockByMinutes,
                is_locked: data.isLocked,
                action_title: data.actionTitle
            });
        });
        this.setState({
            visible: false,
            dialogTitle: "",
            action_val: 0,
            actions_avail: [],
            completed_attempts_count: 0,
            block_by_minutes: 0,
            is_locked: false,
            action_title: ""
        });
        this.doReSetRules();
    };
    DlgSmsRestrictionEditor.prototype.doReSetRules = function () {
        this.setState({
            action_rules: { isError: false },
            completed_attempts_count_rules: { isError: false },
            block_by_minutes_rules: { isError: false },
        });
    };
    DlgSmsRestrictionEditor.prototype.componentWillUnmount = function () {
        this.props.controller.UnSubscribe(this.SID);
    };
    DlgSmsRestrictionEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        var is_data_valid = true;
        if (this.state.action_val <= 0) {
            this.setState({
                action_rules: {
                    isError: true,
                    errorMessage: "Поле [Тип действия] не выбрано!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.completed_attempts_count <= 0) {
            this.setState({
                completed_attempts_count_rules: {
                    isError: true,
                    errorMessage: "Поле [Количество попыток] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        if (this.state.block_by_minutes <= 0) {
            this.setState({
                block_by_minutes_rules: {
                    isError: true,
                    errorMessage: "Поле [блокировка, минут] не заполнено!"
                },
            });
            is_data_valid = false;
        }
        return is_data_valid;
    };
    DlgSmsRestrictionEditor.prototype.handleYes = function () {
        if (this.isDataValid()) {
            this.props.controller.Close();
            if (this.props.controller.DATA.onYes) {
                this.props.controller.DATA.onYes(this.state.action_val, this.state.completed_attempts_count, this.state.block_by_minutes, this.state.is_locked);
            }
        }
    };
    DlgSmsRestrictionEditor.prototype.handleClose = function () {
        this.props.controller.Close();
    };
    DlgSmsRestrictionEditor.prototype.OnCountChanged = function (value) {
        this.props.controller.SetCompletedAttemptsVal(value, true);
    };
    DlgSmsRestrictionEditor.prototype.OnMinutesChanged = function (value) {
        this.props.controller.SetBlockByMinutes(value, true);
    };
    DlgSmsRestrictionEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(antd_1.Modal, { title: this.state.dialogTitle, visible: this.state.visible, onOk: this.handleYes.bind(this), wrapClassName: "vertical-center-modal", onCancel: this.handleClose.bind(this), okText: "\u0414\u0410", cancelText: "\u041D\u0415\u0422", closable: true, maskClosable: false, okType: "primary", style: { minWidth: 600 } },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", } },
                React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип SMS сообщения:", placeholder: "Выберите тип SMS сообщения" }, value: { key: this.state.action_val, value: this.state.action_title.toString() }, onValueChanged: function (newVal) {
                        _this.setState({
                            action_val: newVal.key,
                            action_title: newVal.value,
                            action_rules: { isError: false }
                        }, function () {
                            _this.props.controller.SetActionVal(_this.state.action_val, true);
                            _this.props.controller.SetActionTitle(_this.state.action_title, true);
                        });
                    }, items: this.state.actions_avail, required: true, rules: this.state.action_rules }),
                React.createElement(CardRowNumericEditor_1.default, { onValueChanged: this.OnCountChanged.bind(this), texts: { caption: "Количество попыток:", placeholder: "Введите количество попыток" }, values: { min: 1, max: 999999, value: this.state.completed_attempts_count } }),
                React.createElement(CardRowNumericEditor_1.default, { onValueChanged: this.OnMinutesChanged.bind(this), texts: { caption: "Блокировка, минут:", placeholder: "Введите время блокировки, минут" }, values: { min: 1, max: 999999, value: this.state.block_by_minutes } }),
                React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заблокирован", value: this.state.is_locked, onChecked: function (checked) { _this.props.controller.SetIsLocked(checked, true); } }))));
    };
    return DlgSmsRestrictionEditor;
}(React.Component));
exports.default = DlgSmsRestrictionEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ui/DlgSmsRestrictionEditor.tsx
// module id = 2552
// module chunks = 0